<template lang="pug">
  header.header#header
    HeaderVideo
    .container
      HeaderTitle
      HeaderSocials
      HeaderCollection(v-if="showCollection")
      HeaderToxis(v-if="showToxisBlock")
</template>

<script>
import Rellax from 'rellax'

import HeaderSocials from './HeaderSocials'
import HeaderTitle from './HeaderTitle'
import HeaderCollection from './HeaderCollection'
import HeaderVideo from './HeaderVideo'
import { mapState } from 'vuex'
import HeaderToxis from './HeaderToxis'

export default {
  name: 'Header',
  components: {
    HeaderToxis,
    HeaderVideo,
    HeaderCollection,
    HeaderTitle,
    HeaderSocials
  },
  mounted () {
    this.$nextTick(() => {
      new Rellax(this.$el, {
        speed: -5
      })
    })
  },
  computed: {
    ...mapState('siteVersions', {
      siteVersion: 'item'
    }),
    showCollection: vm => ['kz'].includes(vm.siteVersion.code),
    showToxisBlock: vm => ['ru'].includes(vm.siteVersion.code)
  }
}
</script>
